import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { TrackingService } from '../../_jaettu-angular/tracking'

@Component({
  selector: 'app-menu-item-button',
  templateUrl: './menu-item-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MenuItemButtonComponent {
  @Input() actionId: string
  @Input() actionContext: any[]
  @Input() additionalClass: string = ''
  @Input() dynamicClass: { [klass: string]: boolean } = {}
  @Input() styles: string = ''
  @Input() matIcon: string = ''
  @Input() disabled = false

  constructor(private _trackingService: TrackingService) {}

  async trackButton() {
    const context = ''
    // if (this.actionContext && this.actionContext.length > 0) {
    //   for (const cntxt of this.actionContext) {
    //     context += JSON.stringify(cntxt)
    //   }
    // }
    this._trackingService.logAction(`${this.actionId} ${context}`)
  }
}
